import React, { useState, useEffect } from 'react';

import DataTable from 'react-data-table-component';
import { Row, Col, Button, Stack, DropdownButton, Dropdown, ButtonGroup } from 'react-bootstrap';

import { Loading } from '../components/Loading';
import CommonUtils from '../utils/siteUtils.js';
import ServiceCalls from '../utils/serviceCalls.js';
import fileDownload from 'js-file-download';
import '../styles/Search.css';

const SearchResults = (props) => { 
    const [hideInvoiceDetails, setHideInvoiceDetails] = React.useState(false);
    const [hideAmountDetails, setHideAmountDetails] = React.useState(true);
    const [hidePaymentDetails, setHidePaymentDetails] = React.useState(true);
    const [hideAdditionalDetails, setHideAdditionalDetails] = React.useState(true);
    const [showAllDetails, setShowAllDetails] = React.useState(false);  
    const [searchData, setSearchData] = useState([]);
    const [localResults, setLocalResults] = useState([]);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(25);
    const [sortOrder, setSortOrder] = useState(false);
    const [sortColumn, setSortColumn] = useState("invoiceNumber");
    const [currentPage, setCurrentPage] = useState(1);
    const [serverPage, setServerPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [currentSupplier, setCurrentSupplier] = useState({})

    const toggleInvoiceDetails = () => {
        setHideInvoiceDetails(false);
        setHideAmountDetails(true);
        setHidePaymentDetails(true);
        setHideAdditionalDetails(true);
        setShowAllDetails(false);
    }

    const toggleAmountDetails = () => {
        setHideInvoiceDetails(true);
        setHideAmountDetails(false);
        setHidePaymentDetails(true);
        setHideAdditionalDetails(true);
        setShowAllDetails(false);
    }

    const togglePaymentDetails = () => {
        setHideInvoiceDetails(true);
        setHideAmountDetails(true);
        setHidePaymentDetails(false);
        setHideAdditionalDetails(true);
        setShowAllDetails(false);
    }

    const toggleAdditionalDetails = () => {
        setHideInvoiceDetails(true);
        setHideAmountDetails(true);
        setHidePaymentDetails(true);
        setHideAdditionalDetails(false);
        setShowAllDetails(false);
    }

    const toggleAllDetails = () => {
        setHideInvoiceDetails(false);
        setHideAmountDetails(false);
        setHidePaymentDetails(false);
        setHideAdditionalDetails(false);
        setShowAllDetails(true);
    }
 

    const exportExcelResults = () => {
        //Export to XLSX
        var dateStr = CommonUtils.formatDate();
        var curSupp = sessionStorage.getItem("curSupName");
        curSupp = (curSupp) ? curSupp : "Supplier";
        /*var fileTitle = `UHG_Supplier_Portal_Export`;*/
       
        //Get all results
        var searchData = props.searchData;
        var isEMEASearch = (currentSupplier.vendorSetId.toUpperCase() !== "UHGID");
        setLoading(true);
        ServiceCalls.exportSearchResultsToExcel(searchData,isEMEASearch).then(function (data) {
            if (data) {
                var fileName = `${dateStr}_UHGSupplier_${curSupp}_Export.xlsx`;         
                fileDownload(data, fileName);
            }
            else {
                console.error("Error exporting results");
            }
            setLoading(false);
        });         
    }

    const exportCSVResults = () => {
        //Export to CSV
        var dateStr = CommonUtils.formatDate();
        var curSupp = sessionStorage.getItem("curSupName");
        curSupp = (curSupp) ? curSupp : "Supplier";
        var isEMEASearch = (currentSupplier.vendorSetId.toUpperCase() !== "UHGID");
        //Get all results
        var searchData = props.searchData;       
        setLoading(true);
        ServiceCalls.exportSearchResultsToCSV(searchData, isEMEASearch).then(function (data) {
            if (data) {
                var fileName = `${dateStr}_UHGSupplier_${curSupp}_Export.csv`;
                fileDownload(data, fileName);
            }
            else {
                console.error("Error exporting results");
            }           
            setLoading(false);
        });        
    }
    const serverPageSize = 1000; 
    
    useEffect(() => {
        if (JSON.stringify(props.searchData) !== JSON.stringify(searchData)) {
            setSearchData(props.searchData);
            setSortOrder(false);
            setSortColumn("invoiceNumber");
            setCurrentPage(1);
            setServerPage(0);
            setTotalPages(0);
            setTotalRows(0);
            var curSupplier = CommonUtils.getCurrentSupplier(props.curSupplierId, props.currentUser);
            setCurrentSupplier(curSupplier);
            performSearch(1, true, 0, sortColumn, sortOrder,perPage);
        }
    }, [props.searchData, searchData, sortColumn, sortOrder, perPage, props.curSupplierId, props.currentUser]);
    //Main Search function
    const performSearch = (page,forceSvrQry,newServerPage,sortBy,sortDir, localPageSize) => {
        setLoading(true);
        //DEBUG console.log(`Search Results - Change to results passed in page ${page} with a size of ${newServerPage}  Should force search:${forceSvrQry}  Sort Order is: ${sortBy} and Dir: ${sortDir}`);
            
        var searchData = props.searchData;
       
        var performSvrSearch = true;
        //check if local results exist before calling server
        if (localResults.length>0) {
            var currentCount = data.length * page;
            var serverCount = serverPageSize * serverPage;
            //DEBUG console.log(`Current local count is ${currentCount} and server count is ${serverCount}  Data length: ${data.length} and passed in Server count ${newServerPage}`);
            performSvrSearch = currentCount > serverCount;
        } 

        if (performSvrSearch || forceSvrQry) {

            //Check if Last page is asked for if so, get all results
            if ((totalRows <= page * perPage) && (page > 1) && (totalRows>0)) {
                //DEBUGconsole.log(`Fetching All for last page  Current Page ${page} Total Pages ${totalPages}  Total Results: ${totalRows}  PageMax:${page * perPage}`);
                searchData["fetchAll"] = true;             
               //DEBUG console.log(`Setting server page to ${totalPages}`);
                setServerPage(totalPages);
            }
            else {
                //Set Server Search Props            
               //DEBUG console.log(`Fetching server page ${newServerPage + 1} to get ${serverPageSize} results.  Current Page ${page} Total Pages ${totalPages}`);
                searchData["fetchAll"] = false;
                setServerPage(newServerPage + 1);
            }
            searchData["page"] = newServerPage + 1;
            searchData["per_page"] = serverPageSize;
            searchData["sort_column"] =sortBy;
            searchData["sort_order"] =sortDir;            
            
            ServiceCalls.getSearchResults(searchData).then(function (data) {
                if (data) {
                    var results = (newServerPage === 0 || searchData["fetchAll"]===true)? data.searchResults : localResults.concat(data.searchResults);
                    setLocalResults(results);
                    setTotalRows(data.total);
                    setTotalPages(data.total_pages);
                    var pageResults = CommonUtils.getSearchResults(results, page, localPageSize);
                    setData(pageResults);
                    setLoading(false);
                    props.onSearchComplete();
                }
                else {
                    setLoading(false);
                }
            });
        }
        else {
            //Return from local data           
            var pageResults = CommonUtils.getSearchResults(localResults, page, localPageSize);
            setData(pageResults);
            setLoading(false);
            props.onSearchComplete();
        }        
};
    const onPageChange = (page) => {
        //console.log(`Search Results - Page changed on search results. Passed in ${page}  Current Server Page: ${serverPage}`);       
        setCurrentPage(page);
        performSearch(page, false, serverPage,sortColumn, sortOrder,perPage);       
    }
    const handlePerRowsChange = async (newPerPage, page) => {
        setPerPage(newPerPage);
        performSearch(page, false, serverPage, sortColumn, sortOrder, newPerPage);
    };
    const handleSort = (column, sortDirection) => {
        // simulate server sort
        setLoading(true);
        setSortColumn(column.id);
        //reset page
        setCurrentPage(1);
        setServerPage(0);
        var sortDir = (sortDirection === 'asc');
        setSortOrder(sortDir);
        //console.log(`Search Results - Sorting on Col ${column.id} Server Page:${serverPage} and Sort Dir: ${sortDirection} with a value of {sortDir}`);
        performSearch(1, true, 0, column.id, sortDir, perPage); 
    };

    const columns = [
        {
            id: 'supplierName',
            name: <span className='dtHeaderCell' title='Supplier Name'>Supplier Name</span>,
            selector: row => row.supplierName,
            sortable: false,
            wrap: true,
            width: (showAllDetails) ? "300px" : "20%",
            omit: hideInvoiceDetails,
            cell: row => <>{(row.supplierName) ? row.supplierName : ' '}</>

        },
        {
            id: 'vendorId',
            name: <span className='dtHeaderCell' title='UHG Supplier ID'>UHG Supplier ID</span>,
            selector: row => row.vendorId,
            sortable: false,
            wrap: false,
            width: (showAllDetails) ? "150px" : "15%",
            omit: hideInvoiceDetails,
            cell: row => <>{(row.vendorId) ? row.vendorId : ' '}</>
        },
        {
            id: 'remitAddressSeqNumber',
            name: <span className='dtHeaderCell' title='Remit Number'>Remit Number</span>,
            selector: row => row.remitAddressSeqNumber,
            sortable: false,
            wrap: false,      
            width: (showAllDetails) ? "150px" : "10%",
            omit: hideInvoiceDetails,
            cell: row => <>{(row.remitAddressSeqNumber) ? row.remitAddressSeqNumber : ' '}</>,
        },
        {
            id: 'voucherId',
            name: <span className='dtHeaderCell' title='Voucher ID'>Voucher ID</span>,
            selector: row => row.voucherId,
            //10-11 DE615117 sortable: true,
            omit: hideInvoiceDetails,
            width: (showAllDetails) ? "150px" : "15%",
            cell: row => <>{(row.voucherId) ? row.voucherId : ' '}</>
        },
        {
            id: 'invoiceNumber',
            name: <span className='dtHeaderCell' title='Invoice ID'>Invoice ID</span>,
            selector: row => row.invoiceNumber,
            //10-11 DE615117 
            //US7338066 - Make sortable for EMEA+ and UHGID
            sortable: true,
            wrap: false,
            width: (showAllDetails) ? "175px" : "15%",
            //omit: !(hideInvoiceDetails || hidePaymentDetails || hideAmountDetails || hideAdditionalDetails),
            cell: row => <>{(row.invoiceNumber) ? row.invoiceNumber : ' '}</>            
        },        
        
        {
            id: 'invoiceDt',
            name: <span className='dtHeaderCell' title='Invoice Date'>Invoice Date</span>,
            selector: row => row.invoiceDt,
            sortable: true, 
            sortType: 'datetime',
            omit: hideInvoiceDetails,
            width: (showAllDetails) ? "150px" : "10%",
            cell: row =><>{(row.invoiceDt) ? CommonUtils.formatDate(row.invoiceDt) : '' }</>
        },
        {
            id: 'grossAmount',
            name: <span className='dtHeaderCell' title='Invoice Amount'>Invoice Amount</span>,
            selector: row => row.grossAmount,
            sortable: true,
            omit: (hideInvoiceDetails && hideAmountDetails),
            right: "true", // right align monetary values
            width: (showAllDetails) ? "150px" : "",
            cell: row => <>{row.grossAmount?CommonUtils.formatAmount(row.grossAmount):'0'}</>
           // cell: row => <div>{handleNull(row.grossAmount)}</div>
        },  
        {
            id: 'paidAmount',
            name: <span className='dtHeaderCell' title='Invoice Amount Paid'>Invoice Amount Paid</span>,
            selector: row => row.paidAmount,
            //10-11 DE615117 sortable: true,
            omit: hideAmountDetails,
            width: (showAllDetails) ? "150px" : "",
            right: "true",
            cell: row => <>{(row.paidAmount) ? CommonUtils.formatAmount(row.paidAmount):'0'}</>
        },
        {
            id: 'discountAmount',
            name: <span className='dtHeaderCell' title='Discount Taken On Invoice'>Discount Taken On Invoice</span>,
            selector: row => row.discountAmount,
            //10-11 DE615117 sortable: true,
            omit: hideAmountDetails,
            width: (showAllDetails) ? "150px" : "",
            right: "true",
            cell: row => <>{(row.discountAmount) ?CommonUtils.formatAmount(row.discountAmount):'0'}</>
        },
        {
            id: 'paymentIdRef',
            name: <span className='dtHeaderCell' title='Payment ID'>Payment ID</span>,
            selector: row => row.paymentIdRef,
            sortable: true,
            center: "true",
            width: (showAllDetails) ? "150px" : "",
            omit: (hideAmountDetails && hidePaymentDetails),
            cell: row => <>{(row.paymentIdRef) ? row.paymentIdRef : ''}</>
        },        
        {
            id: 'paymentAmount',
            name: <span className='dtHeaderCell' title='Payment Amount'>Payment Amount</span>,
            selector: row => row.paymentAmount,
            sortable: true,
            omit: (hideAmountDetails && hidePaymentDetails),
            width: (showAllDetails) ? "150px" : "",
            right: "true",
            cell: row => <>{(row.paymentAmount)?CommonUtils.formatAmount(row.paymentAmount):'0'}</>
        },
        {
            id: 'paymentMethod',
            name: <span className='dtHeaderCell' title='Payment Method'>Payment Method</span>,
            selector: row => row.paymentMethod,
            //10-11 DE615117 sortable: true,
            center: "true",
            width: (showAllDetails) ? "150px" : "",
            omit: hidePaymentDetails,
            cell: row => <>{(row.paymentMethod) ? row.paymentMethod : ' '}</>
        },
        {
            id:'paymentStatus',
            name: <span className='dtHeaderCell' title='Payment Status'>Payment Status</span>,
            selector: row => row.paymentStatus,
            //10-11 DE615117 sortable: true,
            center: "true",
            width: (showAllDetails) ? "150px" : "",
            omit: hidePaymentDetails,
            cell: row => <>{(row.paymentStatus) ? row.paymentStatus : ''}</>
        },   
        {
            id: 'scheduledPayDt',
            name: <span className='dtHeaderCell' title='Scheduled Payment Date'>Scheduled Payment Date</span>,
            selector: row => row.scheduledPayDt,
            sortable: true,
            sortType: 'datetime',
            width: (showAllDetails) ? "165px" : "",
            omit: hidePaymentDetails,
            cell: row => <>{(row.scheduledPayDt) ? CommonUtils.formatDate(row.scheduledPayDt) : ''}</>
        },
        {
            id: 'paymentDt',
            name: <span className='dtHeaderCell' title='Payment Date'>Payment Date</span>,
            selector: row => row.paymentDt,
            sortable: true,
            sortType: 'datetime',
            width: (showAllDetails) ? "150px" : "",
            omit: hidePaymentDetails,
            cell: row => <>{(row.paymentDt) ? CommonUtils.formatDate(row.paymentDt) : ''}</>
        },
        {
            id: 'paymentCurrencyCode',
            name: <span className='dtHeaderCell' title='Payment Currency'>Payment Currency</span>,
            selector: row => row.paymentCurrencyCode,
            //10-11 DE615117 sortable: true,
            omit: hideAdditionalDetails,
            width: (showAllDetails) ? "125px" : "10%",
            cell: row => <>{(row.paymentCurrencyCode) ? row.paymentCurrencyCode : ' '}</>
        },
        {
            id: 'payeeBankAccount',
            name: <span className='dtHeaderCell' title='Bank Account Number'>Bank Account Number</span>,
            selector: row => row.payeeBankAccount,
            //10-11 DE615117 sortable: true,
            wrap: false,
            width: (showAllDetails) ? "150px" : "15%",
            omit: hideAdditionalDetails,
            cell: row => <>{(row.payeeBankAccount) ? row.payeeBankAccount : ' '}</>
        },
        {
            id: 'payingDescription',
            name: <span className='dtHeaderCell' title='UHG Company Name'>UHG Company Name</span>,
            selector: row => row.payingDescription,
            //10-11 DE615117 sortable: true,
            omit: hideAdditionalDetails,
            wrap: false,
            width: (showAllDetails) ? "200px" : "15%",
            cell: row => <>{(row.payingDescription) ? row.payingDescription : ''}</>
        },
        {
            id: 'apBusinessUnit',
            name: <span className='dtHeaderCell' title='AP Business Unit'>AP Business Unit</span>,
            selector: row => row.apBusinessUnit,
            //10-11 DE615117 sortable: true,
            width: (showAllDetails) ? "150px" : "10%",
            omit: hideAdditionalDetails,
            cell: row => <>{(row.apBusinessUnit) ? row.apBusinessUnit : ''}</>
        },
        {
            id: 'apBuDescription',
            name: <span className='dtHeaderCell' title='Legal Entity Description'>Legal Entity Description</span>,
            selector: row => row.apBuDescription,
            //10-11 DE615117 sortable: true,
            omit: hideAdditionalDetails,
            width: (showAllDetails) ? "225px" : "15%",
            wrap: true,
            cell: row => <>{(row.apBuDescription) ? row.apBuDescription : ''}</>
        },    
        {
            id: 'remittanceDescription',
            name: <span className='dtHeaderCell' title='Remittance Description'>Remittance Description</span>,
            selector: row => row.remittanceDescription ,
            sortable: false,
            omit: hideAdditionalDetails, 
            width: (showAllDetails) ? "470px" : "",
            wrap: true,      
            cell: row => <>{(row.remittanceDescription) ? row.remittanceDescription : ''}</>
        }
    ];
    const emea_columns = [
        {
            id: 'supplierName',
            name: <span className='dtHeaderCell' title='Supplier Name'>Supplier Name</span>,
            selector: row => row.supplierName,
            sortable: false,
            wrap: true,
            width: (showAllDetails) ? "300px" : "20%",
            omit: hideInvoiceDetails,
            cell: row => <>{(row.supplierName) ? row.supplierName : ' '}</>

        },
        {
            id: 'vendorId',
            name: <span className='dtHeaderCell' title='UHG Supplier ID'>UHG Supplier ID</span>,
            selector: row => row.vendorId,
            sortable: false,
            wrap: false,
            width: (showAllDetails) ? "150px" : "15%",
            omit: hideInvoiceDetails,
            cell: row => <>{(row.vendorId) ? row.vendorId : ' '}</>
        },
        {
            id: 'poNumber',
            name: <span className='dtHeaderCell' title='PO Number'>PO Number</span>,
            selector: row => row.poNumber,
            sortable: false,
            wrap: false,
            width: (showAllDetails) ? "150px" : "10%",
            omit: hideInvoiceDetails,
            cell: row => <>{(row.poNumber) ? row.poNumber : ' '}</>,
        },
        {
            id: 'voucherId',
            name: <span className='dtHeaderCell' title='Voucher ID'>Voucher ID</span>,
            selector: row => row.voucherId,
            //10-11 DE615117 sortable: true,
            omit: hideInvoiceDetails,
            width: (showAllDetails) ? "150px" : "15%",
            cell: row => <>{(row.voucherId) ? row.voucherId : ' '}</>
        },
        {
            id: 'invoiceNumber',
            name: <span className='dtHeaderCell' title='Invoice ID'>Invoice ID</span>,
            selector: row => row.invoiceNumber,
            //US7338066 - Make sortable for EMEA+ and UHGID
            sortable: true,
            wrap: false,
            width: (showAllDetails) ? "175px" : "15%",
            //omit: !(hideInvoiceDetails || hidePaymentDetails || hideAmountDetails || hideAdditionalDetails),
            cell: row => <>{(row.invoiceNumber) ? row.invoiceNumber : ' '}</>
        },
        {
            id: 'invoiceDt',
            name: <span className='dtHeaderCell' title='Invoice Date'>Invoice Date</span>,
            selector: row => row.invoiceDt,
            sortable: true,
            sortType: 'datetime',
            omit: hideInvoiceDetails,
            width: (showAllDetails) ? "150px" : "10%",
            cell: row => <>{(row.invoiceDt) ? CommonUtils.formatDate(row.invoiceDt) : ''}</>
        },
        {
            id: 'grossAmount',
            name: <span className='dtHeaderCell' title='Invoice Amount'>Invoice Amount</span>,
            selector: row => row.grossAmount,
            sortable: true,
            omit: (hideInvoiceDetails && hideAmountDetails),
            right: "true", // right align monetary values
            width: (showAllDetails) ? "150px" : "",
            cell: row => <>{row.grossAmount ? CommonUtils.formatAmount(row.grossAmount) : '0'}</>
            // cell: row => <div>{handleNull(row.grossAmount)}</div>
        },
        {
            id: 'paidAmount',
            name: <span className='dtHeaderCell' title='Invoice Amount Paid'>Invoice Amount Paid</span>,
            selector: row => row.paidAmount,
            //10-11 DE615117 sortable: true,
            omit: hideAmountDetails,
            width: (showAllDetails) ? "150px" : "",
            right: "true",
            cell: row => <>{(row.paidAmount) ? CommonUtils.formatAmount(row.paidAmount) : '0'}</>
        },
        {
            id: 'invoiceCurrency',
            name: <span className='dtHeaderCell' title=' Invoice Currency'>Invoice Currency</span>,
            selector: row => row.invoiceCurrency,
            center: "true",
            omit: hideAmountDetails,
            width: (showAllDetails) ? "150px" : "",
            cell: row => <>{(row.invoiceCurrency) ? row.invoiceCurrency : '0'}</>
        },
        {
            id: 'paymentIdRef',
            name: <span className='dtHeaderCell' title='Payment ID'>Payment ID</span>,
            selector: row => row.paymentIdRef,
            sortable: true,
            center: "true",
            width: (showAllDetails) ? "150px" : "",
            omit: (hideAmountDetails && hidePaymentDetails),
            cell: row => <>{(row.paymentIdRef) ? row.paymentIdRef : ''}</>
        },
        {
            id: 'paymentAmount',
            name: <span className='dtHeaderCell' title='Payment Amount'>Payment Amount</span>,
            selector: row => row.paymentAmount,
            sortable: true,
            right:"true",
            omit: (hideAmountDetails && hidePaymentDetails),
            width: (showAllDetails) ? "150px" : "",
            cell: row => <>{(row.paymentAmount) ? CommonUtils.formatAmount(row.paymentAmount) : '0'}</>
        },
        {
            id: 'paymentCurrencyCode',
            name: <span className='dtHeaderCell' title='Payment Currency'>Payment Currency</span>,
            selector: row => row.paymentCurrencyCode,
            center: "true",
            omit: (hideAmountDetails && hidePaymentDetails),
            width: (showAllDetails) ? "125px" : "10%",
            cell: row => <>{(row.paymentCurrencyCode) ? row.paymentCurrencyCode : ' '}</>
        },
        {
            id: 'paymentMethod',
            name: <span className='dtHeaderCell' title='Payment Method'>Payment Method</span>,
            selector: row => row.paymentMethod,
            //10-11 DE615117 sortable: true,
            center: "true",
            width: (showAllDetails) ? "150px" : "",
            omit: hidePaymentDetails,
            cell: row => <>{(row.paymentMethod) ? row.paymentMethod : ' '}</>
        },
        {
            id: 'paymentStatus',
            name: <span className='dtHeaderCell' title='Payment Status'>Payment Status</span>,
            selector: row => row.paymentStatus,
            //10-11 DE615117 sortable: true,
            center: "true",
            width: (showAllDetails) ? "150px" : "",
            omit: hidePaymentDetails,
            cell: row => <>{(row.paymentStatus) ? row.paymentStatus : ''}</>
        },
        {
            id: 'paymentDt',
            name: <span className='dtHeaderCell' title='Payment Date'>Payment Date</span>,
            selector: row => row.paymentDt,
            sortable: true,
            sortType: 'datetime',
            width: (showAllDetails) ? "150px" : "",
            omit: hidePaymentDetails,
            cell: row => <>{(row.paymentDt) ? CommonUtils.formatDate(row.paymentDt) : ''}</>
        },      
        {
            id: 'payeeBankAccount',
            name: <span className='dtHeaderCell' title='Bank Account Number'>Bank Account Number</span>,
            selector: row => row.payeeBankAccount,
            //10-11 DE615117 sortable: true,
            wrap: false,
            width: (showAllDetails) ? "150px" : "15%",
            omit: hideAdditionalDetails,
            cell: row => <>{(row.payeeBankAccount) ? row.payeeBankAccount : ' '}</>
        },
        {
            id: 'bankName',
            name: <span className='dtHeaderCell' title='Bank Name'>Bank Name</span>,
            selector: row => row.bankName,
            //10-11 DE615117 sortable: true,
            omit: hideAdditionalDetails,
            wrap: false,
            width: (showAllDetails) ? "200px" : "15%",
            cell: row => <>{(row.bankName) ? row.bankName : ''}</>
        },
        {
            id: 'apBusinessUnit',
            name: <span className='dtHeaderCell' title='AP Business Unit'>AP Business Unit</span>,
            selector: row => row.apBusinessUnit,
            //10-11 DE615117 sortable: true,
            width: (showAllDetails) ? "150px" : "10%",
            omit: hideAdditionalDetails,
            cell: row => <>{(row.apBusinessUnit) ? row.apBusinessUnit : ''}</>
        },
        {
            id: 'apBuDescription',
            name: <span className='dtHeaderCell' title='Legal Entity Description'>Legal Entity Description</span>,
            selector: row => row.apBuDescription,
            //10-11 DE615117 sortable: true,
            omit: hideAdditionalDetails,
            width: (showAllDetails) ? "225px" : "",
            wrap: true,
            cell: row => <>{(row.apBuDescription) ? row.apBuDescription : ''}</>
        }
    ];

    const customStyles = {
        // search results DataTable custom styles
        table: {
            style: {
                // table styles
                padding: '0',
                margin: '0'
            },
        },
        headCells: {
            style: {
                // header styles
                fontSize: '14px',
                justifyContent: 'left !important',
                color: 'white',
                paddingLeft: '1%',
                borderRight: '1px solid white',
                fontWeight: '400',
                
            },
        },
        head: {
            style: {
                // head styles - so calendars go over
                zIndex: '99'
            },
        },
        headRow: {
            style: {
                // header styles
                backgroundColor: '#003C71',
            },
        },
    };

    return (
        (loading)
            ? <div><Loading /></div>
                : <>       
                  <Row id="resultsRow">
                    <Col xs={12} sm={9}>
                            <Stack direction="horizontal">
                                <Button onClick={() => toggleInvoiceDetails()} title="Show Invoice Columns" className={(!hideInvoiceDetails && !showAllDetails) ? "resultsTabs" : "resultsTabs unselected"}>Invoice Details</Button>
                                <Button onClick={() => toggleAmountDetails()} title="Show Amount Columns" className={(!hideAmountDetails && !showAllDetails) ? "resultsTabs" : "resultsTabs unselected"}>Amount Details</Button>
                                <Button onClick={() => togglePaymentDetails()} title="Show Payment Columns" className={(!hidePaymentDetails && !showAllDetails) ? "resultsTabs" : "resultsTabs unselected"}>Payment Details</Button>
                                <Button onClick={() => toggleAdditionalDetails()} title="Show Additional Columns" className={(!hideAdditionalDetails && !showAllDetails) ? "resultsTabs" : "resultsTabs unselected"}>Additional Details</Button>
                                <Button onClick={() => toggleAllDetails()} title="Show All Columns" className={(showAllDetails) ? "resultsTabs" : "resultsTabs unselected"}> All </Button>
                            </Stack>
                        </Col>
                    <Col sm={2} className="searchResultsArea">
                        <div className="searchResultsCountPill"><span className="searchResultsPill">{totalRows}</span> Results</div>
                        </Col>
                     <Col sm={1}>
                            <ButtonGroup className="exportButtonGrp" style={{ float:"right"}}>
                            <DropdownButton
                                title="Export Results"
                                id="bg-nested-dropdown">
                                <Dropdown.Item eventKey="1" onClick={() => exportCSVResults()}>CSV</Dropdown.Item>
                                <Dropdown.Item eventKey="2" onClick={() => exportExcelResults()}>Excel</Dropdown.Item>
                            </DropdownButton>
                        </ButtonGroup>
                    </Col>  
            </Row>
            <Row>
                <Col xs={12} id="searchResults">
                        <DataTable
                            keyField="index"
                            columns={(currentSupplier.vendorSetId.toUpperCase() === "UHGID") ?columns:emea_columns}
                            data={data}
                           // progressPending={loading}
                            fixedHeader
                            striped
                            responsive
                            pagination
                            paginationServer   
                            onSort={handleSort}
                            sortServer
                            defaultPageSize={perPage}
                            paginationTotalRows={totalRows}
                            onChangeRowsPerPage={handlePerRowsChange}
                            onChangePage={onPageChange}
                            paginationDefaultPage={currentPage}
                            paginationRowsPerPageOptions={[25,50,100]}
                            paginationPerPage={perPage}
                            customStyles={customStyles}
                            defaultSortFieldId={sortColumn}
                            defaultSortAsc={sortOrder}                         
                    />
                </Col>
            </Row>
          </>
        )
}
export default SearchResults



